/* ==========================================================================
   TWCA GALLERY JS  —  desktop hero arrows only.
   Routes a hero-arrow click to the next/prev THUMBNAIL click. Mobile = native.
   ========================================================================== */
(function () {
  var DESKTOP = '(min-width: 750px)';

  function arrowsFor(gallery) {
    return {
      prev: gallery.querySelector(
        'slider-component.slider-mobile-gutter:not(.thumbnail-slider) .slider-button--prev'
      ),
      next: gallery.querySelector(
        'slider-component.slider-mobile-gutter:not(.thumbnail-slider) .slider-button--next'
      )
    };
  }

  function syncEnds(gallery, index, total) {
    var a = arrowsFor(gallery);
    if (a.prev) a.prev.toggleAttribute('disabled', index <= 0);
    if (a.next) a.next.toggleAttribute('disabled', index >= total - 1);
  }

  function thumbsIn(gallery) {
    return Array.prototype.slice.call(
      gallery.querySelectorAll('.thumbnail-list__item .thumbnail')
    );
  }

  function activeIndex(thumbs) {
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].hasAttribute('aria-current')) return i;
    }
    return 0;
  }

  function onClick(e) {
    var btn = e.target.closest(
      'media-gallery slider-component.slider-mobile-gutter:not(.thumbnail-slider) .slider-button'
    );
    if (!btn) return;
    if (!window.matchMedia(DESKTOP).matches) return;

    var gallery = btn.closest('media-gallery');
    if (!gallery) return;
    var thumbs = thumbsIn(gallery);
    if (thumbs.length < 2) return;

    var idx = activeIndex(thumbs);
    var target = btn.classList.contains('slider-button--next') ? idx + 1 : idx - 1;
    if (target < 0 || target >= thumbs.length) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    thumbs[target].click();
    syncEnds(gallery, target, thumbs.length);
  }

  function init() {
    if (!window.matchMedia(DESKTOP).matches) return;
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      var thumbs = thumbsIn(gallery);
      if (thumbs.length < 2) return;
      syncEnds(gallery, activeIndex(thumbs), thumbs.length);
    });
  }

  document.addEventListener('click', onClick, true);
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();